// import { WEBPACK_HASH } from './constants';

export const pipe =
    <T>(...fns: Array<(v: T) => T>) =>
    (x: T): T =>
        fns.reduce((v, f) => f(v), x);

export const normalize = <T, K extends keyof T>(key: K, arr: T[]): Record<string, T> => {
    return arr.reduce<Record<string, T>>((acc, curr) => {
        acc[String(curr[key])] = curr;
        return acc;
    }, {});
};

export const getTimeComponents = (date: Date) => {
    let hours: number | string = date.getHours();
    let minutes: number | string = date.getMinutes();

    if (hours < 10) {
        hours = '0' + hours;
    }

    if (minutes < 10) {
        minutes = '0' + minutes;
    }

    return { hours, minutes };
};

export const getGamesMinDenomination = (
    games: Array<{ minDenomination: Map<string, number> }>,
    currency: string,
): number => games?.map<number>((game) => game.minDenomination.get(currency) || 1).sort((a, b) => a - b)[0] || 1;

export const wait = (time: number): Promise<void> => {
    return new Promise((res) => {
        setTimeout(() => res(), time);
    });
};
